<div
	class="text-secondary"
	[class]="{
		'ui-time-picker--disabled': disabled(),
	}"
>
	<div
		class="w-full flex gap-1"
		uiDropdown
		[ignoreTrigger]="!readOnlyInput()"
		(openChange)="onDropdownStateChange($event)"
		#dropdown
	>
		<div
			class="flex bg-standard items-center w-full duration-300 h-10 py-px px-3 border rounded border-secondary-300 border-solid pr-0"
			[class]="{
				'border-focus!': focused(),
				'bg-secondary-100 text-secondary-400': disabled(),
				'border-error!': !focused() && invalid() && touched(),
				'border-success!': !focused() && !invalid() && showWhenValid() && displayValue(),
			}"
			uiDropdownTrigger
		>
			<input
				type="text"
				class="w-full border-none grow outline-none overflow-hidden p-0 duration-300 placeholder:color-secondary-400 placeholder:opacity-100 dark:text-secondary-900"
				[class]="{
					'bg-secondary-100 color-secondary-400': disabled(),
					'cursor-pointer!': readOnlyInput(),
				}"
				[value]="displayValue()"
				[disabled]="disabled()"
				(input)="onInput($event)"
				[placeholder]="placeholder()"
				[readonly]="readOnlyInput()"
				(focusout)="onFocusOut()"
				(focusin)="focused.set(true)"
				[id]="'input-time-' + id"
				(keydown.enter)="$event.preventDefault()"
				#inputElement
			/>
			<div>
				<span>
					@if (showWhenValid()) {
						<!-- Failure Icon | When the input is not valid -->
						@if (invalid() && displayValue()) {
							<ui-icon
								icon="failures"
								type="error"
								class="hover:cursor-pointer"
								[class]="{ 'hover:cursor-default': disabled() }"
								size="s"
							>
							</ui-icon>
						}
						<!-- Success Icon | When the input is valid -->
						@if (!invalid() && displayValue()) {
							<ui-icon
								icon="x_check"
								type="success"
								class="hover:cursor-pointer"
								[class]="{ 'hover:cursor-default': disabled() }"
								size="s"
							>
							</ui-icon>
						}
					} @else {
						<ui-button
							[icon]="icon()"
							type="link-dark"
							iconSize="m"
							(buttonClicked)="openDropdown()"
						></ui-button>
					}
				</span>
			</div>
		</div>
		<ng-container *uiDropdownContent>
			<div
				#dropdownContent
				class="p-4 flex sm:gap-2 justify-center items-center focus-visible:border-focus focus-visible:border-1 focus-visible:outline-none"
				tabindex="-1"
			>
				<div class="flex gap-2 flex-col">
					<ui-button
						icon="x_arrow_up"
						type="link-dark"
						(buttonClicked)="setTimeViaArrows('hours', 'up')"
					></ui-button>
					<span class="select-none text-center">
						{{ displayValue() | timePickerHour: timeFormat }}
					</span>
					<ui-button
						icon="x_arrow_down"
						type="link-dark"
						(buttonClicked)="setTimeViaArrows('hours', 'down')"
					></ui-button>
				</div>
				<span class="select-none">:</span>
				<div class="flex gap-2 flex-col">
					<ui-button
						icon="x_arrow_up"
						type="link-dark"
						(buttonClicked)="setTimeViaArrows('minutes', 'up')"
					></ui-button>
					<span class="select-none text-center">
						{{ displayValue() | timePickerMinute }}
					</span>
					<ui-button
						icon="x_arrow_down"
						type="link-dark"
						(buttonClicked)="setTimeViaArrows('minutes', 'down')"
					></ui-button>
				</div>
				@if (timeFormat === TimeFormat.TWELVE_HOUR && !useAsTimeLength()) {
					<div class="flex gap-2 flex-col ml-1 justify-center">
						<ui-button
							icon="x_arrow_up"
							type="link-dark"
							(buttonClicked)="handleAmPmToggle()"
						></ui-button>
						<span class="select-none text-center">
							{{ twentyFourHourValue() | timePickerAmPm }}
						</span>
						<ui-button
							icon="x_arrow_down"
							type="link-dark"
							(buttonClicked)="handleAmPmToggle()"
						></ui-button>
					</div>
				}
			</div>
		</ng-container>
	</div>

	<div
		[class]="{
			'text-error': !focused() && invalid() && touched(),
			'text-success': !focused() && !invalid() && showWhenValid() && displayValue(),
		}"
	></div>
</div>
